<template>
    <div id="app" >
        <loading v-if="$root.loading"></loading>
            <router-view v-else></router-view>
    


    </div>
</template>

<script>
import loading from "@/components/Loading.vue";
    export default {
        name: 'App',
        components: {
            loading
        },
        mounted() {
            $(window).resize(function() {
                $('#app').addClass('anim-stopper ')
                setTimeout(() => {
                 $('#app').removeClass('anim-stopper ')
                        }, 400)
            })

            $(window).on("orientationchange", function() {
                $('#app').addClass('anim-stopper ')
                setTimeout(() => {
                 $('#app').removeClass('anim-stopper ')
                        }, 400)
            })
        
        },
        methods: {
            callRoute(path) {
                this.$router.push(path)
            }
            
        }
    }

</script>

<style rel=preload>
    @import './assets/css/mainStyles.css';


</style>
